import { useThemeColors } from '@/shared/theme/useThemeColors';
import { radius } from '@/shared/theme/tokens';

export function SkeletonCard({ rows = 3, height = 90, style = {} }) {
  const c = useThemeColors();

  return (
    <div style={{
      background: c.bgMuted,
      borderRadius: radius['2xl'],
      border: `1px solid ${c.borderSubtle}`,
      padding: '20px',
      overflow: 'hidden',
      position: 'relative',
      height,
      ...style,
    }}>
      <style>{`
        @keyframes ripik-skeleton-pulse {
          0% { opacity: 1; }
          50% { opacity: 0.4; }
          100% { opacity: 1; }
        }
      `}</style>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} style={{
            height: '12px',
            borderRadius: radius.sm,
            background: c.bgShimmer ?? c.bgSubtle,
            width: i === 0 ? '60%' : i === rows - 1 ? '40%' : '85%',
            animation: `ripik-skeleton-pulse 1.6s ease-in-out ${i * 0.15}s infinite`,
          }} />
        ))}
      </div>
    </div>
  );
}

export function SkeletonGrid({ count = 3, cardHeight = 180 }) {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
      gap: '16px',
    }}>
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} rows={4} height={cardHeight} />
      ))}
    </div>
  );
}

export function SkeletonTable({ rows = 5 }) {
  const c = useThemeColors();

  return (
    <div style={{
      background: c.bg,
      borderRadius: radius.xl,
      border: `1px solid ${c.borderSubtle}`,
      overflow: 'hidden',
    }}>
      <style>{`
        @keyframes ripik-skeleton-pulse {
          0% { opacity: 1; }
          50% { opacity: 0.4; }
          100% { opacity: 1; }
        }
      `}</style>
      {/* Header */}
      <div style={{ display: 'flex', gap: '12px', padding: '12px 20px', background: c.bgSubtle }}>
        {[30, 20, 25, 15].map((w, i) => (
          <div key={i} style={{ height: '10px', borderRadius: radius.xs, background: c.bgShimmer ?? c.bgMuted, width: `${w}%`, animation: `ripik-skeleton-pulse 1.6s ease-in-out ${i * 0.1}s infinite` }} />
        ))}
      </div>
      {/* Rows */}
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} style={{ display: 'flex', gap: '12px', padding: '14px 20px', borderTop: `1px solid ${c.divider}` }}>
          {[30, 20, 25, 15].map((w, i) => (
            <div key={i} style={{ height: '10px', borderRadius: radius.xs, background: c.bgShimmer ?? c.bgMuted, width: `${w}%`, animation: `ripik-skeleton-pulse 1.6s ease-in-out ${(r + i) * 0.1}s infinite` }} />
          ))}
        </div>
      ))}
    </div>
  );
}
